// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: oJPOUfnhGs

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicOriginalLinkButton.module.css"; // plasmic-import: oJPOUfnhGs/css

import OpenExternallyIcon from "./icons/PlasmicIcon__OpenExternally"; // plasmic-import: cB2UULTKx/icon

createPlasmicElementProxy;

export type PlasmicOriginalLinkButton__VariantMembers = {
  expanded: "websites" | "youtube" | "spotify";
  size: "small" | "big";
};
export type PlasmicOriginalLinkButton__VariantsArgs = {
  expanded?: SingleChoiceArg<"websites" | "youtube" | "spotify">;
  size?: SingleChoiceArg<"small" | "big">;
};
type VariantPropType = keyof PlasmicOriginalLinkButton__VariantsArgs;
export const PlasmicOriginalLinkButton__VariantProps =
  new Array<VariantPropType>("expanded", "size");

export type PlasmicOriginalLinkButton__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicOriginalLinkButton__ArgsType;
export const PlasmicOriginalLinkButton__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicOriginalLinkButton__OverridesType = {
  originalLinkButton?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
};

export interface DefaultOriginalLinkButtonProps {
  children?: React.ReactNode;
  expanded?: SingleChoiceArg<"websites" | "youtube" | "spotify">;
  size?: SingleChoiceArg<"small" | "big">;
  className?: string;
}

const $$ = {};

function PlasmicOriginalLinkButton__RenderFunc(props: {
  variants: PlasmicOriginalLinkButton__VariantsArgs;
  args: PlasmicOriginalLinkButton__ArgsType;
  overrides: PlasmicOriginalLinkButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "expanded",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.expanded
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isOriginalLinkButtonHover, triggerOriginalLinkButtonHoverProps] =
    useTrigger("useHover", {});
  const triggers = {
    hover_originalLinkButton: isOriginalLinkButtonHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"originalLinkButton"}
      data-plasmic-override={overrides.originalLinkButton}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.originalLinkButton,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.originalLinkButtonexpanded_spotify]: hasVariant(
            $state,
            "expanded",
            "spotify"
          ),
          [sty.originalLinkButtonexpanded_websites]: hasVariant(
            $state,
            "expanded",
            "websites"
          ),
          [sty.originalLinkButtonexpanded_youtube]: hasVariant(
            $state,
            "expanded",
            "youtube"
          )
        }
      )}
      data-plasmic-trigger-props={[triggerOriginalLinkButtonHoverProps]}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxexpanded_spotify]: hasVariant(
            $state,
            "expanded",
            "spotify"
          ),
          [sty.freeBoxexpanded_websites]: hasVariant(
            $state,
            "expanded",
            "websites"
          ),
          [sty.freeBoxexpanded_youtube]: hasVariant(
            $state,
            "expanded",
            "youtube"
          )
        })}
      >
        {p.renderPlasmicSlot({
          defaultContents: "View on Twitter",
          value: args.children,
          className: classNames(sty.slotTargetChildren, {
            [sty.slotTargetChildrenexpanded_spotify]: hasVariant(
              $state,
              "expanded",
              "spotify"
            ),
            [sty.slotTargetChildrenexpanded_websites]: hasVariant(
              $state,
              "expanded",
              "websites"
            ),
            [sty.slotTargetChildrenexpanded_youtube]: hasVariant(
              $state,
              "expanded",
              "youtube"
            ),
            [sty.slotTargetChildrensize_big]: hasVariant($state, "size", "big")
          })
        })}
      </div>
      <OpenExternallyIcon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames(projectcss.all, sty.svg, {
          [sty.svgexpanded_spotify]: hasVariant($state, "expanded", "spotify"),
          [sty.svgexpanded_websites]: hasVariant(
            $state,
            "expanded",
            "websites"
          ),
          [sty.svgexpanded_youtube]: hasVariant($state, "expanded", "youtube")
        })}
        role={"img"}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  originalLinkButton: ["originalLinkButton", "freeBox", "svg"],
  freeBox: ["freeBox"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  originalLinkButton: "div";
  freeBox: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicOriginalLinkButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicOriginalLinkButton__VariantsArgs;
    args?: PlasmicOriginalLinkButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicOriginalLinkButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicOriginalLinkButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOriginalLinkButton__ArgProps,
          internalVariantPropNames: PlasmicOriginalLinkButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOriginalLinkButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "originalLinkButton") {
    func.displayName = "PlasmicOriginalLinkButton";
  } else {
    func.displayName = `PlasmicOriginalLinkButton.${nodeName}`;
  }
  return func;
}

export const PlasmicOriginalLinkButton = Object.assign(
  // Top-level PlasmicOriginalLinkButton renders the root element
  makeNodeComponent("originalLinkButton"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicOriginalLinkButton
    internalVariantProps: PlasmicOriginalLinkButton__VariantProps,
    internalArgProps: PlasmicOriginalLinkButton__ArgProps
  }
);

export default PlasmicOriginalLinkButton;
/* prettier-ignore-end */
